import { defineComponent, PropType } from 'vue'
import UEI from '../use/useEditInfo'
import { quickBarMethods } from '../utils/quickBar'
import { IContainer } from '../../../json-parse/src/interface'
import { basicLayout } from '../../../json-parse/src/tools/register'

const TreeItem =  defineComponent({
  name: 'JsonComponentTree',
  props: {
    // 布局容器
    layout: {
      type: Object as PropType<IContainer>,
      default: () => (basicLayout)
    }
  },
  setup(props, ctx) {
    // 重置当前的激活元素
    function setLayout() {
      UEI.setClickLayout(props.layout)
      UEI.setClickElement(UEI.layoutAndDocumentMap.get(props.layout))
    }
    return () => {
      return (
        <div class="comp-tree-item">
          <div class="comp-tree-item-text" onClick={setLayout} 
            style={UEI.state.clickLayout===props.layout?{background:'#40a9ff',color:'#fff'}:{}}
          >
            {
            props.layout && props.layout.children && props.layout.children.length ?
            <i class="k-icon icon-add-fill"></i>:null}
            {props.layout.tag}
          </div>
          {
            props.layout && props.layout.children && props.layout.children.length ?
            props.layout.children.map(item => {
              return <TreeItem layout={item}/>
            }):null
          }
        </div>
      )
    }
  }
})

export default defineComponent({
  name: 'JsonComponentTree',
  components: {TreeItem},
  setup(props, ctx) {
    return () => {
      // const layout = UEI.state.clickLayout
      const layout = UEI.state.globalLayout
      return (
        <div class="comp-tree">
          <TreeItem layout={layout}/>
        </div>
      )
    }
  }
})
